import { styled } from "styled-components";
import { useSearchspringPLPContext } from "../../contexts/SearchspringPLPContext";
import PLPFilterList from "./PLPFilterList";

const OuterContainer = styled.div<{ $isOpen: boolean; }>`
  display: none;
  position: absolute;
  top: 88px;
  left: 0;
  width: 360px;
  height: 100vh;
  background-color: white;
  transform: translateX(-360px);
  transition: transform 600ms ease;
  overflow: scroll;

  ${({ $isOpen }) => $isOpen && `
    transform: translateX(0);
  `}

  @media (min-width: 1024px) {
    display: block;
  }
`;

const InnerContainer = styled.div`
  padding: 0 40px 130px 72px;
`;

const PLPFilterDesktop = () => {
  const { filterMenuOpen } = useSearchspringPLPContext();

  return (
    <OuterContainer $isOpen={filterMenuOpen}>
      <InnerContainer>
        <PLPFilterList />
      </InnerContainer>
    </OuterContainer>
  );
}

export default PLPFilterDesktop;